module.exports = __webpack_public_path__ + "main/images/learnmore/pocket-text-logo.2f77bbdad67c986c8140ff4b2c3b3109.svg";